import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiUsers, FiCrown, FiExternalLink } = FiIcons;

const Membership = () => {
  const tiers = [
    {
      name: "Friends Circle",
      icon: FiUsers,
      price: "$4.99/month",
      benefits: [
        "Support the mission",
        "Early video access",
        "Members-only community posts",
        "Monthly behind-the-scenes content"
      ],
      color: "from-purple-500 to-[#ffc700]"
    },
    {
      name: "Linda's GURLS",
      icon: FiCrown,
      price: "$9.99/month",
      benefits: [
        "Everything in Friends Circle",
        "VIP status with special shoutouts",
        "Live chat during premieres",
        "Exclusive Q&A sessions",
        "Priority response to comments"
      ],
      color: "from-[#ffc700] to-cyan-400",
      featured: true
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-purple-900 to-gray-900">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#ffc700] to-cyan-400 bg-clip-text text-transparent">
            Join Linda's Circle
          </h2>
          <p className="text-xl text-gray-300 mb-6">
            Become a member of the sass squad and support the mission
          </p>
          <div className="flex items-center justify-center gap-2 text-gray-400">
            <SafeIcon icon={FiStar} className="text-[#ffc700]" />
            <span>Support scam awareness education</span>
            <SafeIcon icon={FiStar} className="text-[#ffc700]" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
          {tiers.map((tier, index) => (
            <motion.div
              key={tier.name}
              className={`relative ${tier.featured ? 'lg:scale-105' : ''}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              {tier.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-[#ffc700] to-cyan-400 text-black px-6 py-2 rounded-full font-bold text-sm">
                  MOST POPULAR
                </div>
              )}

              <div className={`bg-gray-800 p-8 rounded-2xl border-2 ${
                tier.featured ? 'border-[#ffc700]' : 'border-gray-700'
              } hover:border-[#ffc700]/50 transition-all duration-300 transform hover:scale-105 h-full`}>
                <div className="text-center mb-6">
                  <div className={`bg-gradient-to-br ${tier.color} p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center`}>
                    <SafeIcon icon={tier.icon} className="text-2xl text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">{tier.name}</h3>
                  <p className="text-3xl font-bold bg-gradient-to-r from-[#ffc700] to-cyan-400 bg-clip-text text-transparent">
                    {tier.price}
                  </p>
                </div>

                <ul className="space-y-3 mb-8">
                  {tier.benefits.map((benefit, i) => (
                    <li key={i} className="flex items-center gap-3 text-gray-300">
                      <SafeIcon icon={FiStar} className="text-[#ffc700] flex-shrink-0" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          viewport={{ once: true }}
        >
          <a
            href="https://www.youtube.com/@LindaRobertsCallsScammers/membership"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-r from-[#ffc700] to-[#ffb700] hover:from-[#ffb700] hover:to-[#ffa700] text-black px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3 shadow-lg"
          >
            <SafeIcon icon={FiExternalLink} className="text-xl group-hover:rotate-12 transition-transform" />
            Join Now on YouTube
          </a>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            Your membership directly supports Linda's mission to educate people about scams and helps create more content to keep everyone safe online.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Membership;